/**
 * How far something is, as a bar with `gevuld/totaal` next to it.
 *
 * Reads faster than the twenty-six plates behind it, and on a collapsed card it is
 * the whole answer: a bar that is a third full says "begonnen" without opening
 * anything. Green only when it is really full, so "bijna" never looks like "klaar".
 */
export function Voortgang({
  gevuld,
  totaal,
  breedte = 52,
}: {
  gevuld: number;
  totaal: number;
  /** Wider where there is room for it, like a panel heading. */
  breedte?: number;
}) {
  const deel = totaal > 0 ? gevuld / totaal : 0;
  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: 8, whiteSpace: 'nowrap' }}>
      <span
        style={{
          width: breedte,
          height: 5,
          borderRadius: 3,
          background: '#EFE6D8',
          overflow: 'hidden',
        }}
      >
        <span
          style={{
            display: 'block',
            height: '100%',
            width: `${Math.round(deel * 100)}%`,
            background: deel === 1 ? '#2A7050' : deel > 0 ? '#E0A943' : '#C9BBA8',
          }}
        />
      </span>
      <span style={{ fontSize: 12, color: '#666666', fontVariantNumeric: 'tabular-nums' }}>
        {gevuld}/{totaal}
      </span>
    </span>
  );
}
